/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WebApiCustomListsDtoMemberConnectionChangeDto
 */
export interface WebApiCustomListsDtoMemberConnectionChangeDto {
    /**
     * 
     * @type {number}
     * @memberof WebApiCustomListsDtoMemberConnectionChangeDto
     */
    memberId?: number;
    /**
     * 
     * @type {string}
     * @memberof WebApiCustomListsDtoMemberConnectionChangeDto
     */
    memberName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiCustomListsDtoMemberConnectionChangeDto
     */
    action?: string | null;
}

/**
 * Check if a given object implements the WebApiCustomListsDtoMemberConnectionChangeDto interface.
 */
export function instanceOfWebApiCustomListsDtoMemberConnectionChangeDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiCustomListsDtoMemberConnectionChangeDtoFromJSON(json: any): WebApiCustomListsDtoMemberConnectionChangeDto {
    return WebApiCustomListsDtoMemberConnectionChangeDtoFromJSONTyped(json, false);
}

export function WebApiCustomListsDtoMemberConnectionChangeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiCustomListsDtoMemberConnectionChangeDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'memberId': !exists(json, 'memberId') ? undefined : json['memberId'],
        'memberName': !exists(json, 'memberName') ? undefined : json['memberName'],
        'action': !exists(json, 'action') ? undefined : json['action'],
    };
}

export function WebApiCustomListsDtoMemberConnectionChangeDtoToJSON(value?: WebApiCustomListsDtoMemberConnectionChangeDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'memberId': value.memberId,
        'memberName': value.memberName,
        'action': value.action,
    };
}

